module.exports = __webpack_public_path__ + "static/img/renyi-s.aaa1b0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/renyi-s.png
// module id = fObw
// module chunks = 1